import React, { useRef } from 'react';
import { Card } from '@iwoca/orion';
import clsx from 'clsx';
import useOnClickOutside from 'use-onclickoutside';

import styles from './DropdownContainer.module.css';

type TProps = {
  children: React.ReactNode;
  className?: string;
  onClose: () => void;
};

export const DropdownContainer = ({ children, className, onClose }: TProps) => {
  const dropdownRef = useRef(null);

  useOnClickOutside(dropdownRef, onClose);

  return (
    <div ref={dropdownRef}>
      <Card className={clsx(styles.dropdown, className)}>{children}</Card>
    </div>
  );
};
